import FaitWalletView from "./FaitWalletView";

export default FaitWalletView ;
